export const generateErrorMessage = (message: string) => {
  const wordsToReplace = ['in the XML', 'XML request'];
  wordsToReplace.forEach((value) => {
    message = message.replace(new RegExp(value, 'g'), '');
  });
  return message;
};
